/*
 * @Author: liyxt
 * @Date: 2020-02-24 11:10:01
 * @LastEditors: liyxt
 * @LastEditTime: 2020-03-02 17:06:36
 * @Description: file content
 */
import React, { cloneElement, isValidElement } from 'react';

export default function Between({ betweenCallback = {}, betweenProps = {}, sep = '-', children }) {
    function createElementByIndex(index) {
        // children(isFirstOne)
        let finalChildren = isValidElement(children) ? children : children(!index),
            props = {},
            callbacks = {};
        Object.entries(betweenProps).forEach(([propname, prop]) => {
            props[propname] = prop[index];
        });

        Object.entries(betweenCallback).forEach(([callbackname, callback]) => {
            callbacks[callbackname] = function(...rest) {
                typeof callback === 'function' && callback(index, ...rest);
            };
        });

        return cloneElement(finalChildren, {
            ...callbacks,
            ...props,
        });
    }
    return (
        <div>
            {createElementByIndex(0)}
            {sep}
            {createElementByIndex(1)}
        </div>
    );
}
